import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ConstructionBoqService } from '../services/constructionBoq.service';
import type { ConstructionBoq } from '../types/construction-boq.types';
import { toast } from 'sonner';

export function useBoqMutations(companyId: string) {
  const queryClient = useQueryClient();

  const createMutation = useMutation({
    mutationFn: (data: Partial<ConstructionBoq>) => ConstructionBoqService.createBoq({ ...data, company_id: companyId }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['construction-boqs'] });
      toast.success('Khởi tạo BOQ mới thành công');
    },
    onError: (error: any) => {
      toast.error('Lỗi khi tạo BOQ: ' + error.message);
    }
  });

  const updateMutation = useMutation({
    mutationFn: ({ id, updates }: { id: string, updates: Partial<ConstructionBoq> }) => 
      ConstructionBoqService.updateBoq(id, updates),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['construction-boqs'] });
      toast.success('Cập nhật BOQ thành công');
    },
    onError: (error: any) => {
      toast.error('Lỗi khi cập nhật: ' + error.message);
    }
  });

  const deleteMutation = useMutation({
    mutationFn: (id: string) => ConstructionBoqService.deleteBoq(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['construction-boqs'] });
      toast.success('Đã xóa BOQ thành công');
    },
    onError: (error: any) => {
      toast.error('Lỗi khi xóa: ' + error.message);
    }
  });

  return {
    createBoq: createMutation.mutateAsync,
    updateBoq: updateMutation.mutateAsync,
    deleteBoq: deleteMutation.mutateAsync,
    isPending: createMutation.isPending || updateMutation.isPending || deleteMutation.isPending,
  };
}
